/* eslint-disable import/prefer-default-export */

export function acceptCookiePolicy() {
  const cookieDate = new Date();
  cookieDate.setFullYear(cookieDate.getFullYear() + 5);

  document.cookie = `cookiePolicyState=accepted; expires=${cookieDate.toString()}`;

  return {
    type: 'ACCEPT_COOKIE_POLICY'
  };
}

export function rejectCookiePolicy() {
  const cookieDate = new Date();
  cookieDate.setFullYear(cookieDate.getFullYear() + 5);

  document.cookie = `cookiePolicyState=rejected; expires=${cookieDate.toString()}`;
  document.cookie = '_ga=; Max-Age=-99999999;';
  document.cookie = '_gid=; Max-Age=-99999999;';

  return {
    type: 'REJECT_COOKIE_POLICY'
  };
}



// WEBPACK FOOTER //
// ./src/browser/application/actions.js